import api from './api.ts';
import {resolveMembersBaseUrl} from './membersApi.ts';

export interface DirectoryPartner {
  id: number;
  display_name: string;
  bio: string;
  photo_url: string | null;
  city: string;
  state: string;
  specialties: string[];
  contact_url: string;
}
export interface DirectoryProfile extends DirectoryPartner {
  status: 'draft' | 'pending' | 'published' | 'rejected';
  revision: number;
  consent: boolean;
  publish_requested: boolean;
}
export interface DirectoryFilters {q?: string; specialty?: string; city?: string; state?: string; offset?: number}
export interface DirectoryPage<T> {items: T[]; total: number; limit: number; offset: number}
export type DirectoryProfileInput = Omit<DirectoryProfile, 'id' | 'status'>;
const base = '/api/members';
const connection = () => ({baseURL: resolveMembersBaseUrl(window.location)});
const mutation = (token: string) => ({...connection(), headers: {'X-Members-CSRF': token}});
export const membersDirectoryApi = {
  list: async (filters: DirectoryFilters = {}) => (await api.get<DirectoryPage<DirectoryPartner>>(`${base}/directory`, {...connection(), params: {...filters, limit: 12}})).data,
  options: async () => (await api.get<{specialties: string[]; cities: string[]; states: string[]}>(`${base}/directory/options`, connection())).data,
  detail: async (id: string) => (await api.get<DirectoryPartner>(`${base}/directory/${encodeURIComponent(id)}`, connection())).data,
  profile: async () => (await api.get<{profile: DirectoryProfile | null}>(`${base}/directory/profile`, connection())).data,
  save: async (profile: DirectoryProfileInput, token: string) => (await api.put<{profile: DirectoryProfile}>(`${base}/directory/profile`, profile, mutation(token))).data,
  moderation: async (status: string, offset = 0) => (await api.get<DirectoryPage<DirectoryProfile>>(`${base}/admin/directory`, {params: {status, offset, limit: 12}})).data,
  publish: async (profile: DirectoryProfile) => (await api.post<{profile: DirectoryProfile}>(`${base}/admin/directory/${profile.id}/publish`, {revision: profile.revision})).data,
  unpublish: async (profile: DirectoryProfile) => (await api.post<{profile: DirectoryProfile}>(`${base}/admin/directory/${profile.id}/unpublish`, {revision: profile.revision})).data,
};
export function directoryStatus(status: string): string {
  return ({draft: 'Rascunho', pending: 'Aguardando revisão', published: 'Publicado', rejected: 'Fora do catálogo'} as Record<string, string>)[status] || 'Em acompanhamento';
}
